@if (heading) {
    <h2 class="key-topic-two-block__heading">{{ heading }}</h2>
}
<section
    class="key-topic-two-block__container"
    [style.gridTemplateColumns]="'repeat(' + topics.length + ', 1fr)'"
    [style.gridTemplateRows]="'repeat(' + topics.length / 2 + ', min-content)'"
    [class.key-topic-two-block__container--odd]="topics.length % 2"
    [class]="'key-topic-two-block__container--' + topics.length"
>
    @for (topic of topics; track $index) {
        <nw-key-topic-two
            [media]="topic?.media"
            [author]="topic?.author"
            [logo]="topic?.logo"
            [step]="topic?.stepped ? $index + 1 : undefined"
            [tooltip]="topic?.tooltip"
            [body]="topic.body"
            [alignment]="topic.alignment"
        >
            <div
                [class.margin-bottom-s]="topic?.stepped"
                [class.key-topic-two-block__container__header--left]="
                    topic.alignment === 'left'
                "
                [class.key-topic-two-block__container__header--center]="
                    topic.alignment === 'center'
                "
                [class.key-topic-two-block__container__header--right]="
                    topic.alignment === 'right'
                "
                data-slot="heading"
            >
                {{ topic.header }}
            </div>
            <div data-slot="nav" [innerHTML]="topic.nav | sanitizeHtml"></div>
        </nw-key-topic-two>
    }
</section>
